import { render, staticRenderFns } from "./UpdateItemModal.vue?vue&type=template&id=031d992f&scoped=true&"
import script from "./UpdateItemModal.vue?vue&type=script&lang=js&"
export * from "./UpdateItemModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateItemModal.vue?vue&type=style&index=0&id=031d992f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d992f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('031d992f')) {
      api.createRecord('031d992f', component.options)
    } else {
      api.reload('031d992f', component.options)
    }
    module.hot.accept("./UpdateItemModal.vue?vue&type=template&id=031d992f&scoped=true&", function () {
      api.rerender('031d992f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Inventory/components/UpdateItemModal.vue"
export default component.exports